// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BannerAds_bannersContainer__d4StB {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px;
}

.BannerAds_header__TemaP {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.BannerAds_addButton__UPWzs {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #ff3333;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.BannerAds_addButton__UPWzs:hover {
  background-color: #ff5252;
  transform: translateY(-2px);
}

.BannerAds_bannerItem__7f\\+Q0 {
  position: relative;
  width: 200px;
  border-radius: 8px;
  overflow: hidden;
  background-color: transparent;
  transition: transform 0.2s ease;
}

.BannerAds_bannerItem__7f\\+Q0:hover {
  transform: scale(1.02);
}

.BannerAds_bannerImage__k39At {
  width: 100%;
  display: block;
  max-height: 250px;
}

.BannerAds_iconsOverlay__eEFsR {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.BannerAds_bannerItem__7f\\+Q0:hover .BannerAds_iconsOverlay__eEFsR {
  opacity: 1;
  color: #E50914;
}

.BannerAds_icon__AQcGg {
  background: rgba(255, 255, 255, 0.8);
  padding: 6px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s ease;
}

.BannerAds_icon__AQcGg:hover {
  background: rgba(255, 255, 255, 1);
}

/* Pagination styles */
.BannerAds_pagination__NACrk {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.BannerAds_paginationButton__RzHlW {
  background-color: #E50914;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.BannerAds_paginationButton__RzHlW:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

.BannerAds_paginationButton__RzHlW:hover:not(:disabled) {
  background-color: #b00710;
}

.BannerAds_pageInfo__vf4PH {
  font-weight: 600;
  color: #fff;
  font-size: 14px;
}

/* Modal styles */
.BannerAds_modalOverlay__mp3cb {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.BannerAds_modalContent__NLTy6 {
  background-color: #18181B;
  padding: 20px;
  border: 1px solid #E50914;
  border-radius: 8px;
  text-align: center;
  max-width: 300px;
  width: 90%;
  color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.BannerAds_modalButtons__-kmxS {
  margin-top: 16px;
  display: flex;
  justify-content: space-around;
}

.BannerAds_modalButton__YHSjv {
  background-color: #E50914;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.BannerAds_modalButton__YHSjv:hover {
  background-color: #b00710;
}

/* Loading state */
.BannerAds_loading__BXwix {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

/* Empty state */
.BannerAds_empty__RhFpp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  gap: 16px;
}

/* Responsive styles */
@media (max-width: 768px) {
  .BannerAds_bannerItem__7f\\+Q0 {
    width: calc(50% - 16px);
  }
}

@media (max-width: 480px) {
  .BannerAds_bannerItem__7f\\+Q0 {
    width: 100%;
  }
  .BannerAds_iconsOverlay__eEFsR {
    flex-direction: row;
    top: 4px;
    right: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/Banner-Ads/BannerAds.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2DAA2D;EAC3D,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,QAAQ;IACR,UAAU;EACZ;AACF","sourcesContent":[".bannersContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 16px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.addButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #ff3333;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 20px;\n  font-weight: 500;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.addButton:hover {\n  background-color: #ff5252;\n  transform: translateY(-2px);\n}\n\n.bannerItem {\n  position: relative;\n  width: 200px;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: transparent;\n  transition: transform 0.2s ease;\n}\n\n.bannerItem:hover {\n  transform: scale(1.02);\n}\n\n.bannerImage {\n  width: 100%;\n  display: block;\n  max-height: 250px;\n}\n\n.iconsOverlay {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.bannerItem:hover .iconsOverlay {\n  opacity: 1;\n  color: #E50914;\n}\n\n.icon {\n  background: rgba(255, 255, 255, 0.8);\n  padding: 6px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.icon:hover {\n  background: rgba(255, 255, 255, 1);\n}\n\n/* Pagination styles */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.paginationButton {\n  background-color: #E50914;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.paginationButton:disabled {\n  background-color: #aaa;\n  cursor: not-allowed;\n}\n\n.paginationButton:hover:not(:disabled) {\n  background-color: #b00710;\n}\n\n.pageInfo {\n  font-weight: 600;\n  color: #fff;\n  font-size: 14px;\n}\n\n/* Modal styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background-color: #18181B;\n  padding: 20px;\n  border: 1px solid #E50914;\n  border-radius: 8px;\n  text-align: center;\n  max-width: 300px;\n  width: 90%;\n  color: #fff;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modalButtons {\n  margin-top: 16px;\n  display: flex;\n  justify-content: space-around;\n}\n\n.modalButton {\n  background-color: #E50914;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.modalButton:hover {\n  background-color: #b00710;\n}\n\n/* Loading state */\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n/* Empty state */\n.empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n  gap: 16px;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .bannerItem {\n    width: calc(50% - 16px);\n  }\n}\n\n@media (max-width: 480px) {\n  .bannerItem {\n    width: 100%;\n  }\n  .iconsOverlay {\n    flex-direction: row;\n    top: 4px;\n    right: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannersContainer": `BannerAds_bannersContainer__d4StB`,
	"header": `BannerAds_header__TemaP`,
	"addButton": `BannerAds_addButton__UPWzs`,
	"bannerItem": `BannerAds_bannerItem__7f+Q0`,
	"bannerImage": `BannerAds_bannerImage__k39At`,
	"iconsOverlay": `BannerAds_iconsOverlay__eEFsR`,
	"icon": `BannerAds_icon__AQcGg`,
	"pagination": `BannerAds_pagination__NACrk`,
	"paginationButton": `BannerAds_paginationButton__RzHlW`,
	"pageInfo": `BannerAds_pageInfo__vf4PH`,
	"modalOverlay": `BannerAds_modalOverlay__mp3cb`,
	"modalContent": `BannerAds_modalContent__NLTy6`,
	"modalButtons": `BannerAds_modalButtons__-kmxS`,
	"modalButton": `BannerAds_modalButton__YHSjv`,
	"loading": `BannerAds_loading__BXwix`,
	"empty": `BannerAds_empty__RhFpp`
};
export default ___CSS_LOADER_EXPORT___;
